/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {ViewChild, HostListener, ComponentRef, ViewContainerRef, Input, ComponentFactoryResolver, Component,
  OnInit, OnDestroy} from '@angular/core';
import {DueDateContentComponent} from './due-date-content/due-date-content.component';

@Component({
  selector: 'due-date',
  templateUrl: 'due-date.component.html',
  styleUrls: ['due-date.component.scss']
})
export class DueDateComponent implements OnInit, OnDestroy {
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @Input() engageDate: Date;
  @Input() turnFrom: number;
  @Input() turnTo: number;
  @Input() disabled = false;
  @Input() dueDate: Date;

  private tooltip: ComponentRef<DueDateContentComponent>;
  private visible: boolean;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver
  ) {}

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  updateValues(dueDate: Date): void {
    this.dueDate = dueDate;
  }

  @HostListener('focusin')
  @HostListener('mouseenter')
  showInfo(): void {
    if (this.visible || !this.dueDate)
      return;

    this.visible = true;
    const factory = this.resolver.resolveComponentFactory(DueDateContentComponent);

    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
    this.tooltip.instance.engageDate = this.engageDate;
    this.tooltip.instance.turnFrom = this.turnFrom;
    this.tooltip.instance.turnTo = this.turnTo;
  }

  @HostListener('focusout')
  @HostListener('mouseleave')
  hideInfo(): void {
    if (!this.visible)
      return;

    this.visible = false;
    if (this.tooltip)
      this.tooltip.destroy();
  }
}
